import { getCookie } from "@origin-digital/origin-auth";

import { BRAZE_SEGMENT_COOKIE, LEGACY_MOVE_CONTENT } from "../consts";
import { isAuthenticated } from "./utils";

// The cohort recognizes returning customers without identifying their account type.
// Entry-page and address rules determine the product type in the uplifted flow.
// The legacy `book` query parameter no longer controls the uplifted CTA.
export const getSalesButtonStatus = async (authenticated?: boolean) => {
  if (authenticated ?? (await isAuthenticated())) return true;
  return getCookie(BRAZE_SEGMENT_COOKIE) === "customers";
};

export const getLegacySalesButtonStatus = async (authenticated: boolean) => {
  const book = new URLSearchParams(window.location.search)
    .get("book")
    ?.toLowerCase();
  if (book === "true") return true;
  if (book === "false") return false;

  return (
    (await getSalesButtonStatus(authenticated)) &&
    !!LEGACY_MOVE_CONTENT.buttonLabelSales
  );
};
